import { environment } from 'src/environments/environment';
import { getNativeAuthScheme } from './native-auth-scheme.util';

const ID_DIGITAL_CALLBACK_PATH = '/user/redirectKc';
const ID_DIGITAL_BROKER_PATH = 'bqm-resource-provider/idDigital';
/** Bundle ID registered in Info.plist. Not the Keycloak scheme (`server.hostname`). */
const ID_DIGITAL_APP_SCHEME = 'com.labanca.labancamobile';
/** App Link hosts. Same list as scripts/app-links.config.json. */
const ID_DIGITAL_HTTPS_HOSTS = new Set(['www.labanca.com.uy', 'bqm-frontend.alabamasolutions.com']);

export interface IdDigitalCallbackParams {
  code: string;
  state: string;
}

export function isIdDigitalCallbackUrl(url: string): boolean {
  const parsed = parseUrl(url);
  if (!parsed || !isAllowedIdDigitalOrigin(parsed)) {
    return false;
  }

  const route = `/${parsed.hostname}${parsed.pathname}`.replace(/\/+$/, '');
  return route.endsWith(ID_DIGITAL_CALLBACK_PATH);
}

export function isIdDigitalErrorUrl(url: string): boolean {
  if (!isIdDigitalCallbackUrl(url)) {
    return false;
  }

  try {
    const parsedUrl = new URL(url);
    if (parsedUrl.searchParams.has('error')) {
      return true;
    }

    const hash = parsedUrl.hash.startsWith('#') ? parsedUrl.hash.slice(1) : parsedUrl.hash;
    return new URLSearchParams(hash).has('error') || hash.includes('error=');
  } catch {
    return url.includes('#error=') || url.includes('?error=') || url.includes('&error=');
  }
}

export function parseIdDigitalCallback(url: string): IdDigitalCallbackParams | null {
  if (!isIdDigitalCallbackUrl(url) || isIdDigitalErrorUrl(url)) {
    return null;
  }

  try {
    const parsedUrl = new URL(url);
    const code = parsedUrl.searchParams.get('code')?.trim();
    const state = parsedUrl.searchParams.get('state')?.trim();

    if (!code || !state) {
      return null;
    }

    return { code, state };
  } catch {
    return null;
  }
}

function parseUrl(url: string): URL | null {
  if (!url) {
    return null;
  }

  try {
    return new URL(url);
  } catch {
    return null;
  }
}

function isAllowedIdDigitalOrigin(parsed: URL): boolean {
  const scheme = parsed.protocol.slice(0, -1);
  if (scheme === getNativeAuthScheme() || scheme === ID_DIGITAL_APP_SCHEME) {
    return true;
  }

  return parsed.protocol === 'https:' && ID_DIGITAL_HTTPS_HOSTS.has(parsed.hostname);
}

export function buildIdDigitalBrokerUrl(code: string, state: string): string {
  const keycloakUrl = environment.keycloak.testing.url;
  const realm = environment.keycloak.testing.realm;
  const query = new URLSearchParams({ code, state });

  return `${keycloakUrl}realms/${realm}/${ID_DIGITAL_BROKER_PATH}?${query.toString()}`;
}
